function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { clsx as i } from "./index.es105.js";
import { Typography as s } from "./index.es35.js";
import { palette as c } from "./index.es36.js";
import { Icon as m } from "./index.es7.js";
import r from "./index.es199.js";

var f = function f(_ref) {
  var _ref$title = _ref.title,
      a = _ref$title === void 0 ? "Something went wrong" : _ref$title,
      n = _ref.description,
      t = _ref.footer,
      e = _ref.isModal;
  return o.jsx("div", {
    className: i(r.container, _defineProperty({}, r.modal, e)),
    children: o.jsxs("div", {
      className: i(r.wrapper, _defineProperty({}, r.modalWrapper, e)),
      children: [o.jsx(m, {
        size: 72,
        color: c.gray6,
        icon: m.icons.inPageImage.warningTriangle
      }), o.jsx(s.Body1, {
        className: r.title,
        children: a
      }), o.jsx(s.Body2, {
        className: r.description,
        children: n
      }), t]
    })
  });
};

export { f as Error };